import {
  ERRORS,
  WARNINGS,
  WARN_FIELDS,
  NOTICES,
  POSTED,
  POST_BUTTON,
  BUSY_INDICATOR,
  BUSY_INTERVAL_ID,
  BUSY_INTERVAL_TS,
  REQUEST_BUSY,
  SET_ERRORS,
  SET_WARNINGS,
  SET_WARN_FIELDS,
  SET_NOTICES,
  PURGE_RESULTS,
  SET_POSTED,
  SET_POST_BUTTON,
  SET_BUSY_INDICATOR,
  SET_BUSY_INTERVAL_ID,
  SET_BUSY_INTERVAL_TS,
  SET_REQUEST_BUSY, REPLACE_WARN_FIELD
} from './postStatus.types'

const state = {
  errors: [],
  warnings: [],
  warnFields: [],
  notices: [],
  posted: false,
  postButton: null,
  busyIndicator: false,
  busyIntervalId: null,
  busyIntervalTs: null,
  requestBusy: false
}

const getters = {
  [ERRORS] (state) {
    return state.errors
  },
  [WARNINGS] (state) {
    return state.warnings
  },
  [WARN_FIELDS] (state) {
    return state.warnFields
  },
  [NOTICES] (state) {
    return state.notices
  },
  [POSTED] (state) {
    return state.posted
  },
  [POST_BUTTON] (state) {
    return state.postButton
  },
  [BUSY_INDICATOR] (state) {
    return state.busyIndicator
  },
  [BUSY_INTERVAL_ID] (state) {
    return state.busyIntervalId
  },
  [BUSY_INTERVAL_TS] (state) {
    return state.busyIntervalTs
  },
  [REQUEST_BUSY] (state) {
    return state.requestBusy
  }
}

const mutations = {
  [SET_ERRORS] (state, errors) {
    state.errors = errors
  },
  [SET_WARNINGS] (state, warnings) {
    state.warnings = warnings
  },
  [SET_WARN_FIELDS] (state, warnFields) {
    state.warnFields = warnFields
  },

  /**
   * Use this if you wish to use a different field name for a
   * warning that was returned from the API. Useful when you
   * have a field name conflict on a single form.
   *
   * @param state
   * @param warnFieldName
   * @param replaceWithFieldName
   */
  [REPLACE_WARN_FIELD] (state, { warnFieldName, replaceWithFieldName }) {
    const warnFields = []
    state.warnFields.forEach((warnField) => {
      if (warnField.hasOwnProperty(warnFieldName)) {
        let newWarnField = {}
        newWarnField[replaceWithFieldName] = warnField[warnFieldName]
        warnFields.push(newWarnField)
      } else {
        warnFields.push(warnField)
      }
    })
    state.warnFields = warnFields
  },

  [SET_NOTICES] (state, notices) {
    state.notices = notices
  },
  [PURGE_RESULTS] (state) {
    state.errors = []
    state.warnings = []
    state.warnFields = []
    state.notices = []
    state.posted = false
    state.pagination = {}
  },
  [SET_POSTED] (state, posted) {
    state.posted = posted
  },
  [SET_POST_BUTTON] (state, postButton) {
    state.postButton = postButton
  },
  [SET_BUSY_INDICATOR] (state, busyIndicator) {
    state.busyIndicator = busyIndicator
  },
  [SET_BUSY_INTERVAL_ID] (state, busyIntervalId) {
    state.busyIntervalId = busyIntervalId
  },
  [SET_BUSY_INTERVAL_TS] (state, busyIntervalTs) {
    state.busyIntervalTs = busyIntervalTs
  },
  [SET_REQUEST_BUSY] (state, requestBusy) {
    state.requestBusy = requestBusy
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/api/postStatus.js